/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {viewWithDataGetPrimaryData} from '../box-utils/PrimaryData';
import {ParentBox, relayWrap} from './../box-utils/ParentBox.react.js';

import Error from './system/Error.react.js';
import {sendError} from '../../app/errorDisplayer';
import BoxDecorator from './../box-utils/BoxDecorator.react';
import config from '../../../common/config';
import {safeJSONparse} from "../../../common/util/safeJSONparse";


let CDN = config.PUBLIC_CDN + '/assets/creditcheck/';

let icons = {
    "1": {
        icon: CDN + "rating_16x16_green.png",
        title: "V databázi Creditcheck nebyly nalezeny žádné informace o skutečnostech nebo změnách ve firmě, které by mohly (ale nemusely) mít vliv na bonitu.	",
        color: "green",
    },
    "2": {
        icon: CDN + "rating_16x16_orange.png",
        title: "Jsou k dispozici informace o skutečnostech nebo změnách ve firmě, které mohou (ale nemusí) mít vliv na bonitu.	",
        color: "orange"
    },
    "3": {
        icon: CDN + "rating_16x16_red.png",
        title: "Jsou k dispozici informace o skutečnostech nebo změnách, které zpravidla mají (ale nemusí) významný vliv na bonitu.	",
        color: "red",
    },
    "4": {
        icon: CDN + "rating_16x16_grey.png",
        title: "Nelze v tuto chvíli určit bonitu společnosti pomocí služby CreditCheck.",
        color: "grey",
    },
};

class CreditCheck extends ParentBox {

    static handlerName = "creditcheck";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "creditcheck";
    }

	getServiceName() {
		return "CreditCheck";
	}

	// eslint-disable-next-line max-params
    renderOneRow(key, name, icon, identNum) {
        return (
            <span key={key}>
                {identNum
                    ?
                    <a href={"https://creditcheck.cz/CCLfree.aspx?cid=F5A4EE27-D3FD-4477-A2C2-A7656605F12C&ic=" + encodeURIComponent(identNum)} target="_blank">{" "}<img className="dativeryValue" src={icon['icon']} title={icon['title']} /></a>
                    :
                    <img className="dativeryValue" src={icon['icon']} title={icon['title']} />
                }
                {" "}<small className="dativeryValue">{name}</small><br/>
            </span>
        );
    }

    render() {
        try {
            let {addon} = this.props.viewWithData;

            addon = safeJSONparse(addon);
            let data = viewWithDataGetPrimaryData(this.props.viewWithData);

            if (this.props.isPreview) {
                data = [
                    {
                        key: '1',
                        'com.dativery.model.entities.companies@name': 'Company Ltd.'
                    }
                ];
                addon['creditcheck'] = {'1': {
                    'semaphore': '1'
                }};
            }

            let creditcheck = addon['creditcheck'];
            if (!creditcheck) {
                creditcheck = {};
            }

			data = data.map((row) => {
				let key = row['key'];

				let result = creditcheck[key];

				let icon = icons['4'];

				if (result && result['semaphore']) {
					icon = icons[result['semaphore']];
				}

				let identNum =
					row['com.dativery.model.components.company.registrationNumbers@czRN'] ||
					row['com.dativery.model.components.company.registrationNumbers@skRN'] ||
					row['com.dativery.model.components.company.registrationNumbers@unRN'];

				let name = row['com.dativery.model.entities.companies@name'] || identNum;

				if (!name) {
					return;
				}

				return this.renderOneRow(key, name, icon, identNum);
			}).filter((row) => {
				return row !== undefined;
			});

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} key="CreditCheck" title={this.getServiceName()} >
                    <div style={{padding: '5px'}}>
                        {data}
                        {data.length === 0 ? this.renderOneRow('-1', '', icons['4']) : null}
                    </div>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(CreditCheck);
